module.exports = __webpack_public_path__ + "static/media/about.036e4af7.jpg";